import { useContext } from 'react'

import { ConfigContext } from './ConfigProvider'

export const useConfig = () => useContext(ConfigContext)
